import { useTranslation } from 'react-i18next';
import { cn } from '@sib/ui';
import { NoInviteesIcon } from '@spendbrain/icons';
import { Invitee } from '@spendbrain/types/user';
import { InviteesListItem } from './InviteesListItem';
import { InviteesListSkeleton } from './InviteesListSkeleton';

interface InviteesListProps {
  data: Invitee[];
  onRemove: (invitee: Invitee) => void;
  loading?: boolean;
}

export const InviteesList = ({
  data,
  onRemove,
  loading,
}: InviteesListProps) => {
  const { t } = useTranslation();
  const count = data.length;

  const isThereAnyInvitee = count > 0;

  return (
    <div className="border-border rounded-sm border-1 shadow-[0px_4px_6px_0px_rgba(0,0,0,0.09)]">
      <div
        className={cn('border-border border-b-1 px-3.5 pt-3.5 pb-1.5', {
          'border-none': !isThereAnyInvitee,
        })}
      >
        <p className="text-primary text-sm leading-[18px] font-semibold">
          {t('components.shareDialog.invited', { count })}
        </p>
      </div>
      {loading ? (
        <InviteesListSkeleton />
      ) : isThereAnyInvitee ? (
        <ul className="max-h-[250px] overflow-y-auto">
          {data.map((item, index) => (
            <InviteesListItem
              onRemove={() => onRemove(item)}
              data={item}
              key={`invitees-list-item-${index}`}
            />
          ))}
        </ul>
      ) : (
        <div className="flex flex-col items-center gap-7 pt-2 pb-4">
          <NoInviteesIcon className="text-primary" />
          <p className="text-muted-foreground text-sm font-medium">
            {t('components.shareDialog.noData')}
          </p>
        </div>
      )}
    </div>
  );
};
